import axios from 'axios'
import api from '@/odooapi'

export const state = {
    currentUser: getSavedState('auth.currentUser'),
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('auth.currentUser', newValue)
        setDefaultAuthHeaders(state)
    },
}

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.currentUser
    },
}

export const actions = {
    // 这是自动运行在' src/state/store.js '当应用程序
    // 启动，以及其他模块中名为' init '的操作。
    init({
             state,
             dispatch
         }) {
        setDefaultAuthHeaders(state)
        // dispatch('validate')
    },

    // 登录当前用户。
    logIn({
              commit,
              dispatch,
              getters
          }, {
              username,
              password
          } = {}) {
        // if (getters.loggedIn) return dispatch('validate')

        return api.web.login({
            // 配置数据库
            db: process.env.VUE_APP_ODOO_DB,
            login: username,
            password: password
        }).then(res => {
            const user = res.session   // 最终在这  登录以后保存 在store
            // const person = {
            //     "uid":user.uid,
            //     "name":user.name,
            // }
            commit('SET_CURRENT_USER',user)
            return user
        })
        .catch(err =>{
            console.log("登陆出错：",err)
        })
        // return axios
        // 	.post('/api/session', {
        // 		username,
        // 		password
        // 	})
        // 	.then((response) => {
        // 		const user = response.data
        // 		commit('SET_CURRENT_USER', user)
        // 		return user
        // 	})
    },

    // Logs out the current user.
    logOut({
               commit
           }) {
        commit('SET_CURRENT_USER', null)
    },

    // register the user
    register({
                 commit,
                 dispatch,
                 getters
             }, {
                 fullname,
                 email,
                 password
             } = {}) {
        // if (getters.loggedIn) return dispatch('validate')

        return axios
            .post('/api/register', {
                fullname,
                email,
                password
            })
            .then((response) => {
                const user = response.data
                return user
            })
    },

    // register the user
    resetPassword({
                      commit,
                      dispatch,
                      getters
                  }, {
                      email
                  } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return axios.post('/api/reset', {
            email
        }).then((response) => {
            const message = response.data
            return message
        })
    },

    // Validates the current user's token and refreshes it
    // with new data from the API.
    // validate({
    //              commit,
    //              state
    //          }) {
    //     if (!state.currentUser) return Promise.resolve(null)

    //     return axios
    //         .get('/api/session')
    //         .then((response) => {
    //             const user = response.data
    //             commit('SET_CURRENT_USER', user)
    //             return user
    //         })
    //         .catch((error) => {
    //             if (error.response && error.response.status === 401) {
    //                 commit('SET_CURRENT_USER', null)
    //             }
    //             return null
    //         })
    // },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
    return JSON.parse(sessionStorage.getItem(key))
}

function saveState(key, state) {
    sessionStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
    axios.defaults.headers.common.Authorization = state.currentUser ?
        state.currentUser.token :
        ''
}
